var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{on:{"selCat":_vm.selCat,"selPrice":_vm.selPrice}}),_c('Middle',{ref:"goodsListContent",attrs:{"msg":"新品专区"},on:{"initCart":_vm.initCart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }